export { BlogAuthorPage, type BlogAuthorPageProps } from "./BlogAuthorPage";
